"use strict";
/**
 * Note this is just an interface, used in the core config.
 * The implementations are located in the @moralisweb3/common-sol-utils package.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.solNetworkNames = void 0;
exports.solNetworkNames = ['mainnet', 'devnet'];
//# sourceMappingURL=SolNetworkish.js.map